import { InputElement } from "../../constants";

// - generate excel file
export default function* (
  title: string,
  elements: InputElement[],
  values: Record<string, any>
) {}
